import { Observable } from 'rxjs';
import { IMasterValue } from 'src/app/core/models/api/master';

export abstract class EditProjectContract {
  abstract checkCondition(model: any): boolean;
  abstract checkClient(model: any): boolean;

  abstract getPaymentTypes(): Observable<IMasterValue[]>;
  abstract getActivities(): Observable<IMasterValue[]>;
  abstract getSports(): Observable<IMasterValue[]>;

  abstract getLivingStandards(): Observable<IMasterValue[]>;
  abstract getChildren(): Observable<IMasterValue[]>;
  abstract getContributionsGeneralReg(): Observable<IMasterValue[]>;
  abstract getContributionsRETA(): Observable<IMasterValue[]>;
  abstract getMutualIncomes(): Observable<IMasterValue[]>;

  abstract getDeadlinesIPT(): Observable<IMasterValue[]>;
  abstract getMaritalStatuses(): Observable<IMasterValue[]>;
  abstract getMotorbikes(): Observable<IMasterValue[]>;
}
